export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10006.71d4d2ed.jpg";